import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import {
  GET_PAYMENT_PROFILE,
  GET_PAYMENT_PROFILE_LIST,
  SAVE_PAYMENT_PROFILE,
  GET_MONERIS_CHECKOUT_REQUEST_DATA,
  GET_MONERIS_CHECKOUT_RECEIPT,
  PAY_USING_CREDIT_CARD,
  GET_MONERIS_CHECKOUT_PAYMENT_METHODS,
  RECORD_PAYMENT,
  TRASH_PAYMENT_PROFILE
} from "../actions";
import {
  getPaymentProfileSuccess,
  getPaymentProfileError,
  getPaymentProfileListSuccess,
  getPaymentProfileListError,
  savePaymentProfileSuccess,
  savePaymentProfileError,
  getMonerisCheckoutRequestDataSuccess,
  getMonerisCheckoutRequestDataError,
  getMonerisCheckoutReceiptSuccess,
  getMonerisCheckoutReceiptError,
  payUsingCreditCardError,
  payUsingCreditCardSuccess,
  getMonerisCheckoutPaymentMethodsSuccess,
  getMonerisCheckoutPaymentMethodsError,
  recordPaymentSuccess,
  recordPaymentError,
  trashPaymentProfileSuccess,
  trashPaymentProfileError
} from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";
const PaymentProfileGetFailed = "Get payment profile fails";
const PaymentProfileListGetFailed = "Get payment profile list fails";
const SavePaymentProfileError = "Save payment profile fails";
const TrashPaymentProfileError = "Payment profile delete fails";
const MonerisCheckoutRequestDataGetFailed = "Get Moneris checkout request data fails";
const MonerisCheckoutReceiptGetFailed = "Get Moneris checkout receipt fails";
const PayUsingCreditCardFailed = "Payment failed";
const MonerisCheckoutPaymentMethodsGetFailed = "Get Moneris checkout payment methods fails";
const RecordPaymentFailed = "Record payment fails";


export function* watchGetPaymentProfile() {
  yield takeEvery(GET_PAYMENT_PROFILE, getPaymentProfile);
}

export function* watchGetPaymentProfileList() {
  yield takeEvery(GET_PAYMENT_PROFILE_LIST, getPaymentProfileList);
}

export function* watchSavePaymentProfile() {
  yield takeEvery(SAVE_PAYMENT_PROFILE, savePaymentProfile);
}

export function* watchTrashPaymentProfile() {
  yield takeEvery(TRASH_PAYMENT_PROFILE, trashPaymentProfile);
}

export function* watchGetMonerisCheckoutRequestData() {
  yield takeEvery(GET_MONERIS_CHECKOUT_REQUEST_DATA, getMonerisCheckoutRequestData);
}

export function* watchGetMonerisCheckoutReceipt() {
  yield takeEvery(GET_MONERIS_CHECKOUT_RECEIPT, getMonerisCheckoutReceipt);
}

export function* watchPayUsingCreditCard() {
  yield takeEvery(PAY_USING_CREDIT_CARD, payUsingCreditCard);
}

export function* watchGetMonerisCheckoutPaymentMethods() {
  yield takeEvery(GET_MONERIS_CHECKOUT_PAYMENT_METHODS, getMonerisCheckoutPaymentMethods);
}

export function* watchRecordPayment() {
  yield takeEvery(RECORD_PAYMENT, recordPayment);
}

const recordPaymentAsync = async (payload) => {
  try {
    const responseObject = await centralApiAxios.post("payments/accept", JSON.stringify(JSON.stringify(payload.requestData)), getActivityHeadersUpdated(payload));
    if (responseObject && responseObject.data) {
      if (responseObject.data.message) {
        return {
          message: responseObject.data.message,
        };
      } else {
        return {
          recordPaymentInfo: responseObject.data,
          message: ""
        };
      }
    } else {
      return {
        message: RecordPaymentFailed,
      };
    }
  }
  catch (err) {
    return {
      message: RecordPaymentFailed,
    };
  }
};

function* recordPayment({ payload }) {
  try {
    const resultReturned = yield call(recordPaymentAsync, payload);
    if (!resultReturned.message) {
      yield put(recordPaymentSuccess(resultReturned));
    } else {
      yield put(recordPaymentError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(recordPaymentError(RecordPaymentFailed));
  }
}

const payUsingCreditCardAsync = async (payload) => {
  try {
    const responseObject = await centralApiAxios.get("payment_profiles/payment/" + payload.paymentProfileId + "?order_id=" + payload.orderId + "&payment_method_id=" + payload.paymentMethodId);
    if (responseObject && responseObject.data) {
      if (responseObject.data.message) {
        return {
          message: responseObject.data.message,
        };
      } else {
        return {
          paymentSuccessInfo: responseObject.data,
          message: ""
        };
      }
    } else {
      return {
        message: PayUsingCreditCardFailed,
      };
    }
  }
  catch (err) {
    return {
      message: PayUsingCreditCardFailed,
    };
  }
};

function* payUsingCreditCard({ payload }) {
  try {
    const resultReturned = yield call(payUsingCreditCardAsync, payload);
    if (!resultReturned.message) {
      yield put(payUsingCreditCardSuccess(resultReturned));
    } else {
      yield put(payUsingCreditCardError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(payUsingCreditCardError(PayUsingCreditCardFailed));
  }
}

const savePaymentProfileAsync = async (paymentProfile) => {
  try {
    const responseObject = paymentProfile.paymentProfileId > 0 ? await centralApiAxios.put("payment_profiles?id=" + paymentProfile.paymentProfileId, paymentProfile) : await centralApiAxios.post("payment_profiles", paymentProfile);
    return {
      paymentProfile: responseObject.data,
      message: ""
    };
  }
  catch (err) {
    return {
      message: SavePaymentProfileError,
    };
  }
};

function* savePaymentProfile({ payload }) {
  try {
    const resultReturned = yield call(savePaymentProfileAsync, payload.paymentProfile);
    if (!resultReturned.message) {
      yield put(savePaymentProfileSuccess(resultReturned));
    } else {
      yield put(savePaymentProfileError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(savePaymentProfileError(SavePaymentProfileError));
  }
}

const trashPaymentProfileAsync = async (payload) => {
  try {
    const responseObject = await centralApiAxios.delete("payment_profiles?id=" + payload.paymentProfileId);
    return {
      successMessage: responseObject.data,
      message: ""
    };
  }
  catch (err) {
    return {
      message: TrashPaymentProfileError,
    };
  }
};

function* trashPaymentProfile({ payload }) {
  try {
    const resultReturned = yield call(trashPaymentProfileAsync, payload);
    if (!resultReturned.message) {
      yield put(trashPaymentProfileSuccess());
    } else {
      yield put(trashPaymentProfileError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(trashPaymentProfileError(TrashPaymentProfileError));
  }
}

const getPaymentProfileListAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("payment_profiles?trashed=false&node_id=" + payload.contactId, getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      return {
        paymentProfileList: dataReturned.data.items,
        message: null,
      };
    }
    return { message: PaymentProfileListGetFailed };
  } catch (error) {
    return {
      message: PaymentProfileListGetFailed,
    };
  }
};

function* getPaymentProfileList({ payload }) {
  try {
    const returnedData = yield call(getPaymentProfileListAsync, payload);
    if (!returnedData.message) {
      yield put(getPaymentProfileListSuccess({ paymentProfileList: returnedData.paymentProfileList }));
    } else {
      yield put(getPaymentProfileListError(returnedData.message));
    }
  } catch (error) {
    yield put(getPaymentProfileListError(error));
  }
}


const getPaymentProfileAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("paymentProfiles/" + payload.profileId);
    if (dataReturned.data) {
      return {
        paymentProfile: dataReturned.data,
        message: null,
      };
    }
    return { message: PaymentProfileGetFailed };
  } catch (error) {
    return {
      message: PaymentProfileGetFailed,
    };
  }
};

function* getPaymentProfile({ payload }) {
  try {
    const returnedData = yield call(getPaymentProfileAsync, payload);
    if (!returnedData.message) {
      yield put(getPaymentProfileSuccess({ paymentProfile: returnedData.paymentProfile }));
    } else {
      yield put(getPaymentProfileError(returnedData.message));
    }
  } catch (error) {
    yield put(getPaymentProfileError(error));
  }
}

const getMonerisCheckoutRequestDataAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.post("payments/redirect", payload.paymentRedirectRequest, getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      if (dataReturned.data.ticketError) {
        return {
          message: dataReturned.data.ticketError,
        };
      } else {
        return {
          monerisCheckoutRequestData: dataReturned.data.preloadRequestJsonString ? JSON.parse(dataReturned.data.preloadRequestJsonString) : dataReturned.data,
          monerisCheckoutTicket: dataReturned.data.ticket,
          message: null,
        };
      }
    }
    return { message: MonerisCheckoutRequestDataGetFailed };
  } catch (error) {
    return {
      message: MonerisCheckoutRequestDataGetFailed,
    };
  }
};

function* getMonerisCheckoutRequestData({ payload }) {
  try {
    const returnedData = yield call(getMonerisCheckoutRequestDataAsync, payload);
    if (!returnedData.message) {
      yield put(getMonerisCheckoutRequestDataSuccess({ monerisCheckoutRequestData: returnedData.monerisCheckoutRequestData, monerisCheckoutTicket: returnedData.monerisCheckoutTicket }));
    } else {
      yield put(getMonerisCheckoutRequestDataError(returnedData.message));
    }
  } catch (error) {
    yield put(getMonerisCheckoutRequestDataError(error));
  }
}

const getMonerisCheckoutReceiptAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("payments/moneris_checkout_receipt?storeId=" + payload.receiptRequestParams.store_id + "&apiToken=" + payload.receiptRequestParams.api_token + "&checkoutId=" + payload.receiptRequestParams.checkout_id + "&ticket=" + payload.receiptRequestParams.ticket + "&orderId=" + payload.receiptRequestParams.orderId, getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      if (dataReturned.data.response && dataReturned.data.response.success == 'true') {
        return {
          monerisCheckoutReceipt: dataReturned.data.response,
          message: null,
        };
      } else {
        return { message: MonerisCheckoutReceiptGetFailed };
      }
    }
    return { message: MonerisCheckoutReceiptGetFailed };
  } catch (error) {
    return {
      message: MonerisCheckoutReceiptGetFailed,
    };
  }
};

function* getMonerisCheckoutReceipt({ payload }) {
  try {
    const returnedData = yield call(getMonerisCheckoutReceiptAsync, payload);
    if (!returnedData.message) {
      yield put(getMonerisCheckoutReceiptSuccess({ monerisCheckoutReceipt: returnedData.monerisCheckoutReceipt }));
    } else {
      yield put(getMonerisCheckoutReceiptError(returnedData.message));
    }
  } catch (error) {
    yield put(getMonerisCheckoutReceiptError(error));
  }
}

const getMonerisCheckoutPaymentMethodsAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get("payment_methods?search_text=Moneris Checkout&trashed=false", getActivityHeadersUpdated(payload));
    if (dataReturned.data) {
      let monerisCheckoutPurchasePaymentMethod = null;
      let monerisCheckoutCardVerificationPaymentMethod = null;
      dataReturned.data.items.forEach(pm => {
        let jsonMetaData = pm.jsonMetaData ? JSON.parse(pm.jsonMetaData) : {};
        if (jsonMetaData.IsCardVarification && !monerisCheckoutCardVerificationPaymentMethod) {
          monerisCheckoutCardVerificationPaymentMethod = pm;
        }
        else if (!monerisCheckoutPurchasePaymentMethod) {
          monerisCheckoutPurchasePaymentMethod = pm;
        }
      });
      return {
        monerisCheckoutPurchasePaymentMethod: monerisCheckoutPurchasePaymentMethod,
        monerisCheckoutCardVerificationPaymentMethod: monerisCheckoutCardVerificationPaymentMethod,
        message: null,
      };
    }
  } catch (error) {
    return {
      message: MonerisCheckoutPaymentMethodsGetFailed,
    };
  }
};

function* getMonerisCheckoutPaymentMethods({ payload }) {
  try {
    const returnedData = yield call(getMonerisCheckoutPaymentMethodsAsync, payload);
    if (!returnedData.message) {
      yield put(getMonerisCheckoutPaymentMethodsSuccess({ monerisCheckoutPurchasePaymentMethod: returnedData.monerisCheckoutPurchasePaymentMethod, monerisCheckoutCardVerificationPaymentMethod: returnedData.monerisCheckoutCardVerificationPaymentMethod }));
    } else {
      yield put(getMonerisCheckoutPaymentMethodsError(returnedData.message));
    }
  } catch (error) {
    yield put(getMonerisCheckoutPaymentMethodsError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchGetPaymentProfile),
    fork(watchGetPaymentProfileList),
    fork(watchGetMonerisCheckoutRequestData),
    fork(watchGetMonerisCheckoutReceipt),
    fork(watchPayUsingCreditCard),
    fork(watchSavePaymentProfile),
    fork(watchTrashPaymentProfile),
    fork(watchGetMonerisCheckoutPaymentMethods),
    fork(watchRecordPayment)
  ]);
}
